import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Pill from '@bibliocommons/pill';
import { bindAll } from '@bibliocommons/utils-react';
import { ChevronLink } from '@bibliocommons/base-links';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';

import { AllCommunityTagsContainer } from './AllCommunityTags';
import TagList from './TagList';

import './CommunityTags.scss';

export default class CommunityTags extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      open: false
    };
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  renderPillTags() {
    return <TagList tags={this.props.tags} tagType={Pill} />;
  }

  renderOverlay() {
    if (this.props.pagination.get('pages') > 1) {
      return (
        <div className="overlay-wrapper">
          <ChevronLink
            className="view-expand-link"
            href="#view-expand-link"
            dataKey="view-expand-link"
            handleClick={this.handleOpen}
            preventDefault
          >
            <span aria-hidden>
              <FormattedMessage id="view_all" />
            </span>
            <ScreenReaderMessage>
              <FormattedMessage id="view_all_tags" />
            </ScreenReaderMessage>
          </ChevronLink>
          <FullScreenOverlayContainer
            open={this.state.open}
            handleClose={this.handleClose}
            overlayKey="all-community-tags-full-screen-overlay"
            dataKey="all-community-tags-full-screen-overlay"
          >
            {this.state.open && <AllCommunityTagsContainer metadataId={this.props.metadataId} />}
          </FullScreenOverlayContainer>
        </div>
      );
    }

    return null;
  }

  render() {
    if (this.props.tags.size === 0) return null;

    return (
      <div className="cp-community-tags">
        <div className="community-tags-heading">
          <FormattedMessage tagName="h3" id="community_tags" />
          {this.renderPillTags()}
        </div>
        {this.renderOverlay()}
      </div>
    );
  }
}

CommunityTags.propTypes = {
  metadataId: PropTypes.string.isRequired,
  tags: ImmutablePropTypes.list.isRequired,
  pagination: ImmutablePropTypes.map
};
